<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">


  <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formularioMarcacion" class="form-group" novalidate>
      <div class="row">
        <div class="form-group col-md-6">
          <app-lfsa-input (change)="listAll()" [control]="formularioMarcacion.get('startDate') | formControl"
                          [id]="'startDate'"
                          [label]="'Ingrese Fecha Inicio*'" [mostrarImg]="false" [placeholder]="'Fecha Inicio'"
                          [rutaImagen]=""
                          [type]="'date'"
                          formControlName="startDate">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input (change)="listAll()" [control]="formularioMarcacion.get('endDate') | formControl"
                          [id]="'endDate'"
                          [label]="'Ingrese Fecha Fin*'" [mostrarImg]="false" [placeholder]="'Fecha Fin'"
                          [rutaImagen]=""
                          [type]="'date'"
                          formControlName="endDate">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formularioMarcacion.get('horaInicio') | formControl" [id]="'horaInicio'"
                          [label]="'Ingrese Hora Inicio*'" [mostrarImg]="false" [placeholder]="'Hora Inicio'"
                          [rutaImagen]=""
                          [type]="'text'"
                          formControlName="horaInicio">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-6">
          <app-lfsa-input [control]="formularioMarcacion.get('horaFin') | formControl" [id]="'horaFin'"
                          [label]="'Ingrese Hora Fin*'" [mostrarImg]="false" [placeholder]="'Hora Fin'" [rutaImagen]=""
                          [type]="'text'"
                          formControlName="horaFin">
          </app-lfsa-input>
        </div>
        <div class="form-group col-md-12 mb-3">
          <div class="form-check">
            <input (change)="checkValue()" [(ngModel)]="break" class="form-check-input" formControlName="break"
                   id="break" type="checkbox">
            <label class="form-check-label" for="break">
              Aplica Break
            </label>
          </div>
        </div>
        <ng-container *ngIf="break">
          <div class="form-group col-md-12 card-title">
            <h5> BREAK-IN y BREAK-OUT </h5>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-input (change)="listAll()" [control]="formularioMarcacion.get('startDateBreak') | formControl"
                            [id]="'startDateBreak'"
                            [label]="'Ingrese Fecha Inicio Break*'" [mostrarImg]="false" [placeholder]="'Fecha Inicio'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="startDateBreak">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-input (change)="listAll()" [control]="formularioMarcacion.get('endDateBreak') | formControl"
                            [id]="'endDateBreak'"
                            [label]="'Ingrese Fecha Fin Break*'" [mostrarImg]="false" [placeholder]="'Fecha Fin'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="endDateBreak">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-input [control]="formularioMarcacion.get('horaInicioBreak') | formControl"
                            [id]="'horaInicioBreak'"
                            [label]="'Ingrese Hora Inicio Break*'" [mostrarImg]="false" [placeholder]="'Hora Inicio'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="horaInicioBreak">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-input [control]="formularioMarcacion.get('horaFinBreak') | formControl" [id]="'horaFinBreak'"
                            [label]="'Ingrese Hora Fin Break*'" [mostrarImg]="false" [placeholder]="'Hora Fin'"
                            [rutaImagen]=""
                            [type]="'text'"
                            formControlName="horaFinBreak">
            </app-lfsa-input>
          </div>
        </ng-container>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                   [formularioValido]="formularioMarcacion.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formulario>
    </form>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row">
          <div *ngIf="recursosHumanos" class="form-group col-md-6">
            <app-lfsa-combo-box
              (change)="listAll()"
              [comboBox]="cmbDepartment"
              [control]="formulario.get('department') | formControl"
              [idOpcion]="'id'" [id]="'department'" [label]="'Departamento'"
              [opcion]="'descripcion'"
              formControlName="department">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-combo-box
              (change)="listAll()"
              [comboBox]="cmbEmployees"
              [control]="formulario.get('id') | formControl"
              [idOpcion]="'id'" [id]="'id'" [label]="'Cedula*'"
              [opcion]="'descripcion'"
              formControlName="id">
            </app-lfsa-combo-box>
          </div>
        </div>
        <div class="row mb-4">
          <div class="form-group col-md-6">
            <app-lfsa-input (change)="listAll()" [control]="formulario.get('startDate') | formControl"
                            [id]="'startDate'"
                            [label]="'Ingrese Fecha Inicio*'" [mostrarImg]="false" [placeholder]="'Fecha Inicio'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="startDate">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-input (change)="listAll()" [control]="formulario.get('endDate') | formControl"
                            [id]="'endDate'"
                            [label]="'Ingrese Fecha Fin*'" [mostrarImg]="false" [placeholder]="'Fecha Fin'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="endDate">
            </app-lfsa-input>
          </div>
        </div>
      </form>
      <div *ngIf="formulario.valid" class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="pagetitle">
            <div class="btn-group-justified" style="float: right;">
              <a (click)="nuevo()" class="btn btn-outline-success">
                <i aria-hidden="true" class="fa fa-plus"></i>
                {{DAT_BTNS.agregarModificacionMarcaciones}}
              </a>
              <button class="btn btn-outline-success" (click)="downloadReport()">Descargar reporte</button>
              <button class="btn btn-outline-success" (click)="downloadReportReplica()">Reporte Replica</button>
              
            </div>
          </div>
        </div>
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style" [pagination]="true"
                           [rowData]="rowData" [rowSelection]="rowSelection"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
